export default "__VITE_ASSET__BgUXCRgy__"